export const getDietTemplatesPageSteps = (t) => [
    {
        target: 'body',
        placement: 'center',
        title: t('tour.dietTemplatesPage.step-welcome-title'),
        content: t('tour.dietTemplatesPage.step-welcome-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="dtp-search"]',
        title: t('tour.dietTemplatesPage.step-search-title'),
        content: t('tour.dietTemplatesPage.step-search-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="dtp-intolerances"]',
        title: t('tour.dietTemplatesPage.step-intolerances-title'),
        content: t('tour.dietTemplatesPage.step-intolerances-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="dtp-illnesses"]',
        title: t('tour.dietTemplatesPage.step-illnesses-title'),
        content: t('tour.dietTemplatesPage.step-illnesses-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="dtp-caloric"]',
        title: t('tour.dietTemplatesPage.step-caloric-title'),
        content: t('tour.dietTemplatesPage.step-caloric-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="dtp-diettype"]',
        title: t('tour.dietTemplatesPage.step-diettype-title'),
        content: t('tour.dietTemplatesPage.step-diettype-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="dtp-grid"]',
        placement: 'top',
        title: t('tour.dietTemplatesPage.step-grid-title'),
        content: t('tour.dietTemplatesPage.step-grid-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="dtp-pagination"]',
        title: t('tour.dietTemplatesPage.step-pagination-title'),
        content: t('tour.dietTemplatesPage.step-pagination-content'),
        disableBeacon: true,
    },
];
